import DOMPurify from 'dompurify'

export default function sanitizeHtml(html) {
    if (!html) return ''
    return DOMPurify.sanitize(html)
}
